import { render } from "./PersonalInformation.vue?vue&type=template&id=0ec67bdc&scoped=true"
import script from "./PersonalInformation.vue?vue&type=script&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&lang=js"

import "./PersonalInformation.vue?vue&type=style&index=0&id=0ec67bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec67bdc"]])

export default __exports__